import React, { Component } from 'react'
import '../card.css'
import { setShape } from '../../../../store/actions/resultInfo'

class Card extends Component {

    async handleClick() {
        let res = this.props.typeText
        if (this.props.typeText === "5’ten Az Taç Yaprak \n Düzenli Şekil")
            res = "5’ten Az Taç Yaprak Düzenli Şekil"
        if (this.props.typeText === "5’ten fazla taç yaprak \n Düzenli Şekil")
            res = "5’ten fazla taç yaprak Düzenli Şekil"
        await setShape(res)
        this.props.history.push("/size")
    }

    render() {
        return (
            <div onClick={() => this.handleClick()} class="card-outer-container result-card-outer-container">
                <div class="card-inner-container type-card-inner-container">
                    <div class="card-image-container">
                        <img class="type-card-image" src={this.props.image} alt={this.props.typeText + " image"} />
                    </div>
                    <div class="card-text-container">
                        <p class="card-text" style={{ whiteSpace: "pre-line" }}>{this.props.typeText}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Card